export default async function presenter (state, appOptions, lastPage, pageOptions) {
  const Presenter = (await import(/* webpackChunkName: 'agave-presenter' */ '../../apps/agave/presenter/index.js')).default

  const appState = state.appStates.activities
  const activity = appState.get('activity')

  return new Presenter({ model: activity })
}
